import { render, staticRenderFns } from "./ChatFloat.vue?vue&type=template&id=08817580&scoped=true"
import script from "./ChatFloat.vue?vue&type=script&lang=js"
export * from "./ChatFloat.vue?vue&type=script&lang=js"
import style0 from "./ChatFloat.vue?vue&type=style&index=0&id=08817580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08817580",
  null
  
)

export default component.exports